import { maxHighlightedElements } from './activitymapsconst';

export class ColorMap {
  // This constant maps to the number of $map-colors in shared.css
  private static readonly NUM_GRADIENTS = maxHighlightedElements;

  private _max: number;
  private _min: number;
  private _diff: number;

  constructor(clickStats: number[]) {
    // Sort the click stats in descending order
    const sortedClickStats = clickStats.sort((a, b) => b - a);
    if (sortedClickStats.length === 0) {
      this._min = 0;
      this._max = 0;
      this._diff = 0;
      return;
    }

    const minIndex = Math.min(ColorMap.NUM_GRADIENTS, sortedClickStats.length) - 1;
    const minElem = sortedClickStats[minIndex];

    this._min = minElem;
    this._max = sortedClickStats[0];
    this._diff = this._max - this._min;
  }

  getGradientIndex(value: number): number {
    if (this._diff === 0) {
      return 1;
    }

    // [0.0 - 1.0] value
    const spread = (value - this._min) / this._diff;

    // [0 - NUM_GRADIENTS) value
    const index = Math.round(spread * (ColorMap.NUM_GRADIENTS - 1));

    // invert the values to match the CSS
    const mapIdx = -(index - ColorMap.NUM_GRADIENTS);

    this.setGradientText(mapIdx, value);
    return mapIdx;
  }

  setGradientText(i: number, count: number | null) {
    const elems = document.getElementsByClassName(`map-key-color-${i}`);

    if (elems.length > 0) {
      elems[0].setAttribute('data-map-count', count ? `${count}` : '');
    }
  }

  clearAllGradientText() {
    for (let i = 1; i <= ColorMap.NUM_GRADIENTS; i++) {
      this.setGradientText(i, null);
    }
  }
}
